module.exports = __webpack_public_path__ + "img/AkinSoft.4cf9c953.png";